module.exports = __webpack_public_path__ + "static/media/tacos.a71b44b0.jpg";